import request from '@/utils/request'

export const getCheckItemsList = ({ page, size, ...params }) => {
  return request({
    url: `/trace/check/items/${page}/${size}`,
    params
  })
}

// 启用/停用：status 1启用 0停用
export const postCheckItemsStatus = (id, status) => {
  return request({
    method: 'post',
    url: `/trace/check/items/status/${id}/${status}`
  })
}

export const postCheckItemsEdit = (data) => {
  return request({
    method: 'post',
    url: '/trace/check/items',
    data
  })
}

export const putCheckItemsAdd = (data) => {
  return request({
    method: 'put',
    url: '/trace/check/items',
    data
  })
}

export const getCheckItemsDetail = (id) => {
  return request({
    url: `/trace/check/items/${id}`
  })
}

export const deleteCheckItemsDel = (id) => {
  return request({
    method: 'delete',
    url: `/trace/check/items/${id}`
  })
}

export const delCheckItemsList = (data) => {
  return request({
    method: 'delete',
    url: '/trace/check/items/all',
    data
  })
}
